
export default "/assets/bars-3-outline.9b0100b0.svg"